// extracted by mini-css-extract-plugin
export default {"careerpage":"Career_careerpage__fIcW2","contact":"Career_contact__hfBV6","openposition":"Career_openposition__7nkZa","openpositionheading":"Career_openpositionheading__FDL8r"};